const KEY = 'fokus_after_login';
const NEW_KEY = 'fokus_invite_just_signed_up';
const PREVIEW_KEY = 'fokus_invite_preview';

function safePath(path) {
  if (typeof path !== 'string') return null;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/accept-invite')) return null;
  return trimmed;
}

export function rememberAfterLogin(path) {
  const safe = safePath(path);
  if (!safe) return;
  try {
    sessionStorage.setItem(KEY, safe);
  } catch {
    /* ignore */
  }
}

export function peekAfterLogin() {
  try {
    return safePath(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function consumeAfterLogin() {
  const path = peekAfterLogin();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return path;
}

export function clearAfterLogin() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function goAfterLogin() {
  const path = consumeAfterLogin() || '/';
  if (window.location.protocol === 'file:') {
    window.location.hash = path;
  } else {
    window.location.href = path;
  }
}

/** New-account invite: only this path earns the download welcome. */
export function markJustSignedUp() {
  try {
    sessionStorage.setItem(NEW_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearJustSignedUp() {
  try {
    sessionStorage.removeItem(NEW_KEY);
  } catch {
    /* ignore */
  }
}

export function peekJustSignedUp() {
  try {
    return sessionStorage.getItem(NEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function consumeJustSignedUp() {
  try {
    const flagged = sessionStorage.getItem(NEW_KEY) === '1';
    sessionStorage.removeItem(NEW_KEY);
    return flagged;
  } catch {
    return false;
  }
}

export function rememberInvitePreview({ email, workspaceName } = {}) {
  const preview = {
    email: String(email || '').trim().toLowerCase(),
    workspaceName: String(workspaceName || '').trim().slice(0, 64),
  };
  if (!preview.email && !preview.workspaceName) return;
  try {
    sessionStorage.setItem(PREVIEW_KEY, JSON.stringify(preview));
  } catch {
    /* ignore */
  }
}

export function peekInvitePreview() {
  try {
    const raw = sessionStorage.getItem(PREVIEW_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const email = String(parsed?.email || '').trim().toLowerCase();
    const workspaceName = String(parsed?.workspaceName || '').trim().slice(0, 64);
    if (!email && !workspaceName) return null;
    return { email, workspaceName };
  } catch {
    return null;
  }
}
